/* eslint-disable eqeqeq */

import { useContext, useState } from "react";
import { useForm } from "@mantine/form";
import { CSVLink } from "react-csv";
import * as XLSX from "xlsx";

import {
  Alert,

  Group,
  Modal,
  MultiSelect,
  Radio,
  Space,
} from "@mantine/core";

import { Button } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

import { DocumentData, collectionGroup, getDoc, getDocs, doc, getFirestore, query, where, collection, orderBy, limit, Timestamp } from "firebase/firestore";

// import _ from "underscore";



import { AddressFromFinder, CustomClaims, Customer, KYC, NotificationMSG, Order, OrderStatusCode, PoliticallyExposedType } from "../types";
import { MyUserDataContext } from "../contexts";
import { DatePicker, DatePickerInput } from "@mantine/dates";
import { fromMantineDate } from "../helpers/mantineDates";


type FormProps = {
  funds: string[];
  statuses: string[];
  manualStatus?: string
  dateField: "created" | "nav_date" | "nav_date_exact"
  dateRange: [string | null, string | null]
  exactNavDate: string | null
};


const GenerateCSVModal = (props: any) => {
  const userContext = useContext(MyUserDataContext);
  let userClaims = userContext.firebaseTokenResult?.claims.customClaims as CustomClaims || {};

  const opened: boolean = props.opened;
  const setOpened = props.setOpened;
  const [confirming, setConfirming] = useState<boolean>(false);
  const [msg, setMsg] = useState<NotificationMSG | null>(null);
  const [downloadReady, setDownloadReady] = useState<boolean>(false);

  const db = getFirestore();

  const headers = [
    //personal info stuff
    { label: "ID", key: "customerObj.id" },
    { label: "Type", key: "type" },
    { label: "Name (en)", key: "customerObj.name_en" },
    { label: "Name (ar)", key: "customerObj.name_ar" },
    { label: "PACI Email", key: "paciData.PersonalData.EmailAddress" },
    { label: "Gender", key: "paciData.PersonalData.Gender" },
    { label: "Civil ID Expiry", key: "paciData.PersonalData.CardExpiryDate" },
    { label: "Birth Date", key: "paciData.PersonalData.BirthDate" },
    { label: "Nationality", key: "paciData.PersonalData.NationalityEn" },
    { label: "Nationality (Arabic)", key: "paciData.PersonalData.NationalityAr" },
    { label: "Manual", key: "manual" },


    //actual order stuff
    { label: "Transferred Amount", key: "transferAmount" },
    { label: "Transfer Date", key: "transferDate" },
    { label: "Order Creation Date", key: "createdDate" },
    { label: "Order Approval Date", key: "approvalDate" },
    { label: "Order Review Date", key: "reviewDate" },
    { label: "Order Creation Timestamp", key: "created" },
    { label: "Post NAV Amount", key: "postNavAmount" },
    { label: "Fees", key: "fees" },
    { label: "Surplus", key: "surplus" },
    { label: "Units", key: "units" },
    { label: "Mobile", key: "customerObj.mobile" },
    { label: "Fund", key: "fund.name_en" },
    { label: "Fund ID", key: "fund.id" },
    { label: "Fund Currency", key: "fund.currency" },
    { label: "IBAN", key: "iban" },
    { label: "Account #", key: "acct" },

    //rm stuff
    { label: "RM Email", key: "rm.email" },
    { label: "RM ID", key: "rm.rm_id" },
    { label: "RM Name", key: "rm.name_en" },
    { label: "RM segment", key: "rm.segment" },

    //fund stuff I guess?
    { label: "NAV Date", key: "nav_date" },
    { label: "NAV Per Unit", key: "nav_per_unit" },


    //status
    { label: "Status", key: "tags.orderStatus.code" },
    //passport stuff
    { label: "Passport Name", key: "customerObj.passportData.fullName" },
    { label: "Passport ID", key: "customerObj.passportData.id" },
    { label: "Passport Expiry", key: "customerObj.passportData.expiryDate" },

    { label: "Civil ID", key: "customerObj.civilID" },
    { label: "Commercial Register", key: "customerObj.commercial_register" },


    { label: "Paid", key: "tags.paid.code" },

    { label: "Address", key: "customerObj.address" },
    { label: "PACI Address", key: "customerObj.address_from_finder.DetailsEnglish" },

    // { label: "Place of Birth", key: "kyc.placeOfBirth" },
    { label: "Country of Birth", key: "kyc.placeOfBirth" },

    { label: "PEP", key: "politicallyExposed" },
    { label: "PEP Reason", key: "pepReason" },
    { label: "High Risk Reason", key: "highRiskReason" },
    { label: "Power of Attorney", key: "powerOfAttorney" },
    { label: "KYC mobile", key: "kyc.mobile" },
    { label: "Voting", key: "voting" },
    { label: "Source of Income", key: "kyc.sourcesOfIncome" },
    { label: "Source of Wealth", key: "kyc.sourcesOfWealth" },
    { label: "Client Classification", key: "clientClassification" },



    //referred by rm stuff
    { label: "Referrer Email", key: "referredBy.email" },
    { label: "Referrer ID", key: "referredBy.rm_id" },
    { label: "Referrer Name", key: "referredBy.name_en" },
    { label: "Referrer Segment", key: "referredBy.segment" },
    { label: "CIF", key: "customerObj.crmID" },
    { label: "risk", key: "kyc.risk_code" },

    //submittedBy rm stufdf
    { label: "Submitted Email", key: "submittedBy.email" },
    { label: "Submitted ID", key: "submittedBy.rm_id" },
    { label: "Submitted Name", key: "submittedBy.name_en" },
    { label: "Submitted Segment", key: "submittedBy.segment" },
    { label: "Client Segment", key: "customerObj.segment" },
  ];


  const [data, setData] = useState<DocumentData[]>([]);

  const getValueByPath = (obj: any, path: string) => {
    if (!obj || !path) return "";
    const parts = path.split(".");
    let current = obj;
    for (const part of parts) {
      if (current == null) return "";
      current = current[part];
    }
    return current ?? "";
  };

  const downloadExcel = () => {
    if (!data || data.length === 0) return;
    const labels = headers.map((h) => h.label);
    const rows = data.map((row) => headers.map((h) => getValueByPath(row, h.key)));
    const ws = XLSX.utils.aoa_to_sheet([labels, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");
    const date = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");
    XLSX.writeFile(wb, `orders_${date}.xlsx`, { bookType: "xlsx" });
  };

  const handleSubmitGenerateCSV = async (data: FormProps) => {

    //ok get each fund of each status into its separate csv file
    console.log("we query with", data);

    // if ((!data.statuses?.length || !data.funds?.length)) {

    //   throw new Error("Please choose the required status(s) and fund(s)");

    // }
    if ((data.statuses?.length * data.funds?.length) + 1 > 30) {

      throw new Error(`Too many combinations. (${(data.statuses?.length * data.funds?.length) + 1}) Please reduce number of chosen attributes`);

    }

    console.log()

    let q = query(collectionGroup(db, "orders"))
    if (data?.manualStatus === "manual") {
      q = query(q, where("manual", "==", true));

    }
    else if (data?.manualStatus === "digital") {
      q = query(q, where("manual", "!=", true));

    }

    // Whole days, inclusive. Only a start date picked = that single day.
    const [rangeStart, rangeEnd] = data.dateRange ?? [null, null];
    if (data.dateField === "nav_date_exact") {
      // NAV dates are saved as local midnight (see nav_date_input), same match the fund page uses.
      if (data.exactNavDate) q = query(q, where("nav_date", "==", Timestamp.fromDate(fromMantineDate(data.exactNavDate)!)));
    } else if (rangeStart) {
      const start = fromMantineDate(rangeStart)!;
      start.setHours(0, 0, 0, 0);
      const end = fromMantineDate(rangeEnd ?? rangeStart)!;
      end.setHours(23, 59, 59, 999);
      q = query(q, where(data.dateField, ">=", Timestamp.fromDate(start)), where(data.dateField, "<=", Timestamp.fromDate(end)));
    }
    if (data.statuses?.length > 0) {
      q = query(q, where("tags.orderStatus.code", "in", data.statuses));
    }

    if (data.funds?.length > 0) {
      q = query(q, where("fund.id", "in", data.funds));
    }

    if (userClaims?.availableSegments) { q = query(q, where("rm.segment", "in", userClaims.availableSegments)) }
    else if (userClaims?.segment) { q = query(q, where("rm.segment", "==", userClaims.segment)) }


    const querySnapshot = await getDocs(q);
    const orders: DocumentData[] = [];

    //I need this to run in parallel, so create an array of promises for fetching customers
    const customerPromises = querySnapshot.docs.map(async (document) => {
      let d = document.data() as Order;

      // let actions = await document.ref.collection('private').doc('actions').get();

      let customerID = d.customerObj?.id;
      // let actionsData = actions.exists ? actions.data()!.approvals || [] : [];

      let actions = doc(db, `customers/${customerID}/orders/${d.id}/private/actions`);
      let actionsData = getDoc(actions);
      console.log("approvalsArray  EXISTS========>", (await actionsData).exists());

      const approvalsArray = (await actionsData).data()?.approvals || [];
      console.log("approvalsDATA  EXISTS========>", (await actionsData).data());
      console.log("approvalsArray ========>", approvalsArray);

      if (customerID) {
        let customerDocRef = doc(db, `customers`, customerID);

        let customerDocPromise = getDoc(customerDocRef); //don't await here

        const kycCollection = collection(customerDocRef, "kyc");
        const kycQuery = query(kycCollection, orderBy("created", "desc"), where("state.status_code", "==", "valid"), limit(1));
        let kycDocPromise = getDocs(kycQuery); // Don't await here

        return Promise.all([customerDocPromise, kycDocPromise, approvalsArray]);

      }
      return null;
    });

    // Fetch all customers and their KYCs in parallel
    const customerAndKYCDocs = await Promise.all(customerPromises);

    // Assign fetched customer data and KYC to corresponding orders
    for (let i = 0; i < querySnapshot.docs.length; i++) {
      let d = querySnapshot.docs[i].data();

      d.createdDate = d.created?.toDate().toLocaleDateString("en-gb");
      d.created = d.created?.toDate().toLocaleString("en-gb");
      d.nav_date = d.nav_date?.toDate().toLocaleDateString("en-gb");
      d.transferDate = d.transferDate?.toDate().toLocaleDateString("en-gb");
      if (!d.referredBy) {
        d.referredBy = d.rm;
      }
      if (!d.submittedBy) {
        d.submittedBy = d.rm;
      }

      if (d.type === "subscription") {
        d.incentive = (d.units || 0) * (d?.nav_per_unit || 0) * 0.01
      }

      let customerAndKYCDocResult = customerAndKYCDocs[i];

      if (customerAndKYCDocResult) {
        let [customerDoc, kycDocs, approvalsArray] = customerAndKYCDocResult;
        let customerData = customerDoc.data();
        let kycData = kycDocs.docs[0]?.data() as KYC | undefined;
        // let approvalsArray = kycDocs.docs[0]?.data() as KYC | undefined;

        if (customerData) {
          //let's format the address from PACI properly.
          let finderAddress = customerData.address_from_finder as AddressFromFinder;

          //this is the format I want:
          // Block:4, St:443, H:15, 
          // Ishbilya, 
          // Kuwait

          //or
          // Block:1, St:Jamal Abdulnaser, Bld:800049, Apt:. 164, 
          // Shuwaikh industrial(1), 
          // Kuwait

          //or
          // Block:11, St:1, Ave:15, H:47, 
          // Sabah AlSalem, 
          // Kuwait


          if (finderAddress) {
            let address = "";
            if (finderAddress.BlockEnglish) { address += "Block:" + finderAddress.BlockEnglish + ", " }
            if (finderAddress.StreetEnglish) { address += "St:" + finderAddress.StreetEnglish.replace("St ", "") + ", " }
            // if (finderAddress.HouseEnglish) { address +=  (finderAddress.FeatureType == "Unit" ? "Bld" : "H") +":" + finderAddress.HouseEnglish + ", " }
            if (finderAddress.HouseEnglish) { address += "H:" + finderAddress.HouseEnglish + ", " }
            // address += "\n";
            if (finderAddress.NeighborhoodEnglish) { address += finderAddress.NeighborhoodEnglish + ", " }
            // address += "\n";
            address += "Kuwait";
            customerData.address = address;
          }

          if (customerData.passportData?.expiryDate) {
            customerData.passportData.expiryDate = (customerData?.passportData?.expiryDate.toDate().toLocaleDateString("en-gb"));
          }
          d.customerObj = customerData;
        }
        else {
          console.log("Couldn't get customer data for order", d?.id, d.customerObj?.id)
        }

        if (kycData) {
          d.kyc = kycData;
          if (d.kyc?.sourcesOfIncome?.length > 0) {
            d.kyc.sourcesOfIncome = d.kyc.sourcesOfIncome?.join(",")
          }
          if (d.kyc.sourcesofWealth?.length > 0) {
            d.kyc.sourcesofWealth = d.kyc.sourcesofWealth?.join(",")
          }
          if (d.kyc.clientNature?.length > 0) {
            d.clientClassification = d.kyc.clientNature?.join(",")
          }
          //some custom fields for closed ended funds investors template.
          d.powerOfAttorney = kycData.powerOfAttorney ? "Yes" : "No";

          // Based On New KYC check 1st politicallyExposedType
          if (kycData.politicallyExposedType) {
            // New KYC - Show type if exposed
            d.politicallyExposed = kycData.politicallyExposedType === PoliticallyExposedType.None
              ? "No"
              : `Yes (${kycData.politicallyExposedType})`; // "Yes (Me)" or "Yes (Family)"
          } else if (kycData.politicallyExposed !== undefined) {
            // Old KYC (boolean)
            d.politicallyExposed = kycData.politicallyExposed ? "Yes" : "No";
          } else {
            d.politicallyExposed = "No";
          }
          // Old KYC: politicallyExposed (boolean) exists
          // New KYC: politicallyExposedType (enum) exists 
          if (kycData.politicallyExposed || kycData.politicallyExposedType) {
            d.pepReason = kycData.politicalPosition;
            if (kycData.relativePoliticalPosition) {
              d.pepReason += " - Relative: " + kycData.relativePoliticalPosition;
            }
          }
          if (kycData.state?.risk_code === "high") {
            d.highRiskReason = kycData.state?.risk;
          }

          d.kyc.risk_code = kycData.state?.risk_code;
        }

        if (approvalsArray?.length) {
          const approvalDate = approvalsArray.find((approvalObj: any) => approvalObj.type === "approve");
          d.approvalDate = approvalDate?.date?.toDate().toLocaleDateString("en-gb");
          const reviewDate = approvalsArray.find((approvalObj: any) => approvalObj.type === "review");
          d.reviewDate = reviewDate?.date?.toDate().toLocaleString("en-gb");
        }
      }
      orders.push(d);
    }

    console.log(orders);
    setData(orders);
    setDownloadReady(true);
  }
  const form = useForm<FormProps>({
    initialValues: {
      funds: [],
      statuses: [],
      manualStatus: "all",
      dateField: "created",
      dateRange: [null, null],
      exactNavDate: null,
    }
  });

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          setMsg(null);
          setOpened(false);
          setConfirming(false)
        }}
        title="Generate CSV"
      >
        <form
          onSubmit={form.onSubmit(async (values) => {
            console.log(values);

            setDownloadReady(false);
            setData([]);
            // setConfirmDialogError(null);
            setMsg(null);
            // props?.setPending(true)

            setConfirming(true);
            console.log("yeaaa we are here");

            try {

              await handleSubmitGenerateCSV(values)

              // setIsError(true);
              setMsg({ type: "success", message: "CSV Created Successfully" });
            } catch (error: any) {
              // setIsError(true);
              console.log(error);
              // setMsg(error.message);
              // setMsg({type:"error",msg:});
              setMsg({ type: "error", message: error.message });


              // setConfirmDialogError(error.message);
            }

            setConfirming(false);

          })}
        >



          <Radio.Group

            label="Manual Status"
            {...form.getInputProps("manualStatus")}
          >
            <Group mt="xs">
              <Radio value={"all"} label="All" defaultChecked />
              <Radio value={"manual"} label="Manual" />
            </Group>
          </Radio.Group>
          {/* <Select
            {...form.getInputProps("manualStatus")}
            label="Select Manual Status"
            placeholder="Manual Status"
            data={
              [{
                "value": "manual",
                "label": "Manual"
              },

              {
                "value": "all",
                "label": "All"
              }
              ]
            }
          /> */}
          <Space h="xl" />

          <MultiSelect
            {...form.getInputProps("statuses")}
            label="Select status tags"
            placeholder="All statuses"
            data={
              Object.keys(OrderStatusCode).map(code => {
                return { value: code, label: code };
              })
            }
          />


          <MultiSelect
            {...form.getInputProps("funds")}
            label="Select funds"
            placeholder="All funds"
            data={[
              { value: '902', label: 'USD MMF' },
              { value: '901', label: 'KWD MMF' },
              { value: '500', label: 'Sukuk' },
              { value: '200', label: 'GCC' },
              { value: '201', label: 'Premier' },
              { value: 'Pfn6bBMWKckyFcr2EKPJ', label: 'UK Fund IV' },
              { value: 'usFund', label: 'US Fund VI' },
              { value: 'XY3ENvdw0UEtjQgLeABZ', label: 'US Ijara II' },
              { value: '3006', label: 'UK Fund V' },
              { value: '3007', label: 'UK Fund VI' },
              { value: '1008', label: 'US Fund VII' },
              { value: '1009', label: 'US Fund VIII' },
              { value: '40003', label: 'Ijara III' },
              { value: '50001', label: 'Trade Finance' },

            ]}
          />



          <Space h="xl" />

          <Radio.Group label="Filter by date" {...form.getInputProps("dateField")}>
            <Group mt="xs">
              <Radio value="created" label="Creation Date" />
              <Radio value="nav_date" label="NAV Date range" />
              <Radio value="nav_date_exact" label="Exact NAV Date" />
            </Group>
          </Radio.Group>
          {form.values.dateField === "nav_date_exact" ? <DatePickerInput
            mt="xs"
            clearable
            label="Exact NAV Date"
            placeholder="All dates"
            {...form.getInputProps("exactNavDate")}
          /> : <DatePickerInput
            mt="xs"
            type="range"
            allowSingleDateInRange
            clearable
            label={form.values.dateField === "nav_date" ? "NAV Date range" : "Creation Date range"}
            description="Click the same day twice (or just once) for a single day"
            placeholder="All dates"
            {...form.getInputProps("dateRange")}
          />}

          <Space h="xl" />
          <Group>
            <Button color="grape" type="submit" loading={confirming}>
              Generate CSV
            </Button>
          </Group>

          <Space h="xl" />

          {msg && (
            <Alert
              icon={<IconAlertCircle size={16} />}
              color={msg.type == "success" ? "green" : "red"}
              title={msg.type == "success" ? "Success" : "Failure"}
            >


              {msg.message}
              <br />
              {downloadReady && (
                <>
                  <CSVLink data={data} headers={(userClaims?.admin || userClaims.oper) ? [...headers,
                  { label: "Incentive", key: "incentive" },
                  ] : headers}>
                    Download CSV
                  </CSVLink>
                  <Button
                    size="xs"
                    variant="light"
                    onClick={downloadExcel}
                    ml="sm"
                  >
                    Download Excel
                  </Button>
                </>
              )}

            </Alert>
          )}

        </form>
      </Modal >
    </>
  );
}

export default GenerateCSVModal;
